var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"fs-adjustments"},[_c('fs-range-filter-wrapper',{attrs:{"routerLink":'/adjustments',"min":"1","max":"100","label":"menu.pixelate"},model:{value:(_vm.value.blocksize),callback:function ($$v) {_vm.$set(_vm.value, "blocksize", $$v)},expression:"value.blocksize"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }